import { createFileRoute } from '@tanstack/react-router';

import { Absence } from '@src/pages';
import { 
  prefetchAbsences,
  prefetchAbsenceTypes,
  prefetchAbsToolResources,
} from '@src/query';

export const Route = createFileRoute('/_app/absence')({
  loader: ({ context }) => {
    const { apiClient } = context;
    prefetchAbsToolResources(apiClient);
    prefetchAbsences(apiClient);
    prefetchAbsenceTypes(apiClient);
  },
  component: Absence,
});
